import AppRoutes from "../AppRoutes/AppRoutes";
import Header from "../../Header";

const PageContent = () => {
  return (
    <>
      <Header />
      <AppRoutes />
    </>
  );
};

export default PageContent;
